module.exports = __webpack_public_path__ + "img/background.dec475a3.svg";